import { NotifyService } from '@farris/ui-notify';
import { DateTimeHelperService } from '@farris/ui-common/date';
import {
    Component, OnInit, Input, EventEmitter, Output, ViewChild, forwardRef, SimpleChanges,
    ElementRef, HostListener, OnChanges, HostBinding, Injector, ComponentRef, ViewContainerRef, ComponentFactoryResolver,
    Renderer2, OnDestroy, AfterViewInit, ApplicationRef, ChangeDetectorRef
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';
import { FarrisDatePickerDirective } from './farris-datepicker.input';
import {
    IMyOptions, IMyDate, IMyDateModel, IMyShortcuts, IMyDateFormat,
    IMyCalendarViewChanged, IMyRangeDateSelection
} from './interfaces/public-api';

import { DefaultView, ShowType, CalToggle } from './enums/public-api';

import { UtilService, DefaultConfigService, DatepickerLocaleService, DatePickerService } from './services/public-api';
import { LocaleService } from '@farris/ui-locale';
import { differenceInSeconds, isDate, isValid, parse } from 'date-fns';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CLICK, EMPTY_STR } from './constants/constants';
import { CommonUtils, OverLayHiddenService } from '@farris/ui-common';
import { MultiSelectedOrderBy, ViewType } from './interfaces/my-options.interface';
import { DynamicData } from './interfaces/dynamic-data-type.interface';

const FARRIS_DP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FarrisDatepickerComponent),
    multi: true
};

@Component({
    selector: 'farris-datepicker',
    exportAs: 'farris-datepicker',
    templateUrl: './farris-datepicker.component.html',
    styles: [
        `
            :host {
                display: block;
            }

            :host .datepicker-clear {
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                z-index: 100;
            }
        `
    ],
    providers: [FARRIS_DP_VALUE_ACCESSOR, UtilService, DefaultConfigService, LocaleService]
})
export class FarrisDatepickerComponent implements OnInit, ControlValueAccessor, OnChanges, OnDestroy, AfterViewInit {

    @HostBinding('class') cls = 'f-cmp-datepicker f-cmp-inputgroup';

    @Input() viewType: ViewType = ViewType.Switch;

    // æ¯å¦ç¦ç¨è¯¥ç»ä»¶
    @Input() disabled = false;
    // æ¯å¦åªè¯»
    @Input() readonly = false;
    // æ¯å¦åªè½éæ©æ°æ®ï¼ä¸å¯é®å¥
    @Input() editable = true;
    // æ¯å¦ä½¿ç¨æ¥æèå´è¾å¥æ¨¡å¼
    @Input() dateRange = false;
    // æ¯å¦ä½¿ç¨æ¶é´è¾å¥æ¡
    @Input() showTime = false;

    @Input() hourStep = 1;
    @Input() minuteStep = 1;
    @Input() secondStep = 1;


    // æ¾ç¤ºç±»å
    @Input() showType: ShowType = ShowType.all;
    // æ¬å°è¯­è¨
    @Input() locale = 'zh-cn';
    // æ¥ææ ¼å¼
    @Input()
    set dateFormat(value: string) {
        if (value) {
            // value æ ¼å¼å½¢å¦ yyyy-MM-dd HH:mm:ss
            // const formArr = 'yyyy-MM-dd HH:mm:ss'.split(' ');
            value = value.replace(/^\s+|\s+$/g, ''); // å»æå·¦å³ç©ºæ ¼
            value = value.replace(/\s+/g, ' '); // å°ä¸­é´çå¤ä¸ªè¿ç»­ç©ºæ ¼ï¼æ¿æ¢ä¸º1ä¸ªç©ºæ ¼
            const formArr = value.split(' ');
            this._dateFormat = formArr[0];
            // å¤ç'yyyy-MM-dd h:mm:ss a'å³12å°æ¶æ¾ç¤ºçæåµ
            if (formArr.length === 3) {
                this._timeFormat = 'h:mm:ss a';
            } else {
                this._timeFormat = formArr[1];
            }
        }

        // this._dateFormat = this._dateFormat ? (this._dateFormat + '').replace(/m/g, 'M') : '';
        if (this._dateFormat) {
            const mm = ['yyyy-mm', 'yyyy/mm', 'yyyyå¹´mm', 'mm/yyyy'];
            const _mm = mm.find(m => this._dateFormat.includes(m));
            if (_mm) {
                this._dateFormat = this._dateFormat.replace(_mm, _mm.replace(/m/g, 'M'));
            }

            if (this._timeFormat && this.showTime) {
                this._dateFormat += ' ' + this._timeFormat;
                if (this._timeFormat.indexOf('æ¶') > -1) {
                    this._timeFormat = this._timeFormat.replace('æ¶', ':').replace('å', ':').replace('ç§', '');
                }
            }
        }

        // this.dateOpts.dateFormat = this._dateFormat;
    }
    get dateFormat(): string {
        return this._dateFormat;
    }
    // æ¯å¦ä½¿ç¨é»è®¤å¼
    @Input() useDefault = false;
    @Input() returnType: 'Object' | 'Date' | 'String' = 'String';
    @Input() returnFormat: string;
    // placeholder
    @Input() placeholder = '';
    @Input() beginPlaceholder = '';
    @Input() endPlaceholder = '';
    /** è¾å¥å¼åååå³é­éæ©é¢æ¿ã é»è®¤ä¸º true */
    @Input() whenValueChangedThenCloseSelectorPanel = true;
    // æå°æ¥æ
    // å å¥æ¥æ¶æ¶åç§åè½
    @Input()
    set minDate(val: any) {
        const type = Object.prototype.toString.call(val);
        let date: Date;
        switch (type) {
            case '[object Date]':
                date = val;
                break;
            case '[object String]':
                if (val) {
                    date = new Date(val);
                } else {
                    date = new Date(1840, 1, 1, 0, 0, 0);
                }
                break;
            case '[object Null]':
                date = new Date(1840, 1, 1, 0, 0, 0);
                break;
            // case null:
            //     date = new Date(1840, 1, 1, 0, 0, 0);
            //     break;
            case '[object Undefined]':
                date = new Date(1840, 1, 1, 0, 0, 0);
                break;
            default:
                date = new Date(1840, 1, 1, 0, 0, 0);
                break;
        }
        if (isValid(date)) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const second = date.getSeconds();
            this._minDate = { year, month, day, hour, minute, second };
        }
    }
    get minDate() {
        return this._minDate;
    }
    // æå¤§æ¥æ
    // å å¥æ¥æ¶æ¶åç§åè½
    @Input()
    set maxDate(val: any) {
        const type = Object.prototype.toString.call(val);
        let date: Date;

        switch (type) {
            case '[object Date]':
                date = val;
                break;
            case '[object String]':
                if (val) {
                    date = new Date(val);
                } else {
                    date = new Date(10000, 1, 1, 0, 0, 0);
                }
                break;
            case '[object Null]':
                date = new Date(10000, 1, 1, 0, 0, 0);
                break;
            // case null:
            //     date = new Date(10000, 1, 1, 0, 0, 0);
            //     break;
            case '[object Undefined]':
                date = new Date(10000, 1, 1, 0, 0, 0);
                break;
            default:
                date = new Date(10000, 1, 1, 0, 0, 0);
                break;
        }
        if (isValid(date)) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const second = date.getSeconds();
            this._maxDate = { year, month, day, hour, minute, second };
        }
    }
    get maxDate() {
        return this._maxDate;
    }
    // éè¦é«äº®æ¾ç¤ºçæ¥æ
    @Input() highlightDates: Array<IMyDate> = [];
    // ç¦ç¨åºåçæ¥æå¼å§æ¶é´
    @Input() disableDateRangesBegin: IMyDate = {
        year: 0,
        month: 0,
        day: 0
    };
    // ç¦ç¨åºåçæ¥æç»ææ¶é´
    @Input() disableDateRangesEnd: IMyDate = {
        year: 0,
        month: 0,
        day: 0
    };
    // ç¦ç¨çæ¥æ
    @Input() disableDates: Array<IMyDate> = [];
    // ä¸å¨ä¸­è¢«ç¦ç¨çæ¥å­
    @Input() disableWeekdays: Array<string> = [];
    // è¢«æ è®°çæ¥æ
    @Input() markDates: Array<IMyDate> = [];
    // è¢«æ è®°çæ¥æçæ¾ç¤ºé¢è²
    @Input() markDatesColor = '#59a1ff';
    // æ¯å¦æ¾ç¤ºç¬¬å å¨
    @Input() showWeekNumbers = false;
    // æ¯å¦æ è®°å¨æ«
    @Input() isMarkWeekends = false;
    // è¢«æ è®°å¨æ«çæ¾ç¤ºé¢è²
    @Input() markWeekendsColor = '#59a1ff';
    // æ¥æèå´æ¨¡å¼ä¸inputçæ¾ç¤ºåå²ç¬¦å
    @Input() dateRangeDatesDelimiter = '~';
    // éç½®å·¦ä¾§ sidebar å¿«æ·é®
    @Input() shortcuts: Array<IMyShortcuts> = [];
    // æ¥æèå´éæ©æ¶ï¼é»è®¤ç»ææä»½ä¸ºå½åæä»½ + monthRangeValue
    @Input() monthRangeValue = 1;
    // æ¥æèå´ï¼å¼å§æ¥æ
    @Input()
    set beginValue(value: string | Date) {
        value = value ? value : '';
        if (value instanceof Date) {
            value = this.dateTo(value);
            this.returnType = 'Date';
        } else {
            if (value.indexOf('T') > -1) {
                value = value.replace('T', ' ');
            }
            this.returnType = 'String';
        }
        this._beginValue = value;
        if (this._initFinished) {
            this.setValue(this._beginValue + this.dateRangeDatesDelimiter + this._endValue);
        }
    }
    get beginValue() {
        return this.dateFrom(this._beginValue, true);
    }
    // æ¥æèå´ï¼ç»ææ¥æ
    @Input()
    set endValue(value: string | Date) {
        value = value ? value : '';
        if (value instanceof Date) {
            value = this.dateTo(value);
            this.returnType = 'Date';
        } else {
            if (value.indexOf('T') > -1) {
                value = value.replace('T', ' ');
            }
            this.returnType = 'String';
        }
        this._endValue = value;
        if (this._initFinished) {
            this.setValue(this._beginValue + this.dateRangeDatesDelimiter + this._endValue);
        }
    }
    get endValue() {
        return this.dateFrom(this._endValue, true);
    }

    /**
     * å¯ç¨å¨ææ¥æå¼è®¾ç½®ï¼é»è®¤ false
     */
    @Input() enableDynamic = false;
    /** åè®¸è®¾ç½®è¿å»æå¤§å¤©æ° */
    @Input() previousMaxDays = 30;
    /** åè®¸è®¾ç½®æªæ¥æå¤§å¤©æ° */
    @Input() futureMaxDays = 30;

    @Input() showClear = true;
    /** æ¾ç¤ºä»å¤©ï¼æ¬å¹´ï¼æ¬æ æé® */
    @Input() showPresent = true;
    /** æ¯å¨èµ·å§æ¥  å¯éå¼ moï¼å¨ä¸  su: å¨æ¥ï¼é»è®¤ä¸º moå¨ä¸ */
    @Input() firstDayOfWeek: 'mo'|'su' = 'mo';

    // clear äºä»¶
    @Output() clear = new EventEmitter();
    // valueChanged äºä»¶
    @Output() valueChange = new EventEmitter();
    // focus äºä»¶
    @Output() focus = new EventEmitter();
    // blur äºä»¶
    @Output() blur = new EventEmitter();
    // beginValueChange
    @Output() beginValueChange = new EventEmitter();
    // endValueChange
    @Output() endValueChange = new EventEmitter();
    // PrevFocus dateRange ç¬¬ä¸ä¸ªæ¥æ
    @Output() PrevFocus = new EventEmitter();
    // NextFocus dateRange ç¬¬äºä¸ªæ¥æ
    @Output() NextFocus = new EventEmitter();

    // close äºä»¶
    @Output() close = new EventEmitter();

    /** å¯ç¨å¤éï¼é»è®¤ false */
    @Input() multiSelect = false;
    @Input() separator = ',';
    /** åè®¸éæ©æ¥æçä¸ªæ°ï¼ 0 æ é */
    @Input() maxSelected = 0;
    /** éä¸­æ¥æçæåºæ¹å¼ï¼é»è®¤ä¸º 'none' å³ä¸æåº */
    @Input() selectedOrderBy: MultiSelectedOrderBy = 'none';


    @ViewChild(FarrisDatePickerDirective) dp: FarrisDatePickerDirective;
    @ViewChild('clearIcon') clearIcon: ElementRef;
    @ViewChild('calendar', { read: ViewContainerRef }) calendarRef: ViewContainerRef;
    @ViewChild('onPrevFocus') PFocus: ElementRef;
    @ViewChild('onNextFocus') NFocus: ElementRef;

    @ViewChild('dateInput') dateInput: ElementRef;

    private cRef: ComponentRef<CalendarComponent> = null;
    private _timeFormat = '';
    private _value = '';
    public _beginValue = '';
    public _endValue = '';
    private _initFinished = false;
    private _timer: any;
    private _dateFormat: string;
    private _minDate: IMyDate = {
        year: 1840,
        month: 1,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0
    };
    private _maxDate: IMyDate = {
        year: 10000,
        month: 1,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0
    };
    set value(v) {
        this._value = v ? v : '';
    }
    get value() {
        return this._value;
    }
    selectedWeek = null;
    dateOpts: IMyOptions = {};
    defaultConfig: IMyOptions;
    localDateOpts: IMyOptions;
    localeConfig: DatepickerLocaleService;
    localeService: LocaleService;
    // å¼å§è¾å¥æ§ä»¶èç¦
    beginFocus = false;
    // ç»æè¾å¥æ§ä»¶èç¦
    endFocus = false;
    // æ´ä½èç¦
    totalFocus = false;

    originTime: any;
    // æ¯å¦å­ç¬¦è¶é¿æ¾ç¤ºTip
    isActiveTip = false;
    private vcRef: ViewContainerRef;
    private cfr: ComponentFactoryResolver;
    private renderer: Renderer2;
    private datePicekrService: DatePickerService;
    _realValue = null;
    private _realRangeValue = null;
    private notifySer: NotifyService;
    private formatedValue = '';
    dtService: DateTimeHelperService = null;
    private _applicationRef: ApplicationRef;

    private _ngControl: NgControl;
    _updateOn = 'change';

    // æ¥æéæ©åè®¾ç½®ä¸º trueï¼ blur äºä»¶å°ä¸ä¼éå¤æ§è¡valueChangedï¼
    // é®çä¿®æ¹æ¶ï¼blur äºä»¶ä¸­ä¼æ§è¡ä¸æ¬¡ valueChanged åï¼å°æ­¤å¼è®¾ä¸º false;
    private _valueChangeEmitted = false;
    private _mousedownEvent = null;
    private closeCalendarHandler = null;
    private cdr: ChangeDetectorRef = null;
    /** ç¼å­éè¿ç¹å»æ¥åçæ°æ®ï¼ç¨äºçæ ¼å¼åæ ¼å¼ä¸æ åæ¶ï¼æ ¼å¼åæ°æ®ã */
    private _SELECT_DATE_ = null;

    dynamicText = '';
    @Input() dynamicValue: DynamicData = null;
    @Output() dynamicValueChange = new EventEmitter();
    @Output() dynamicViewChanged = new EventEmitter();

    onModelChange = (obj: any) => { };
    onModelTouched = () => { };

    private commonUtils: CommonUtils;

    private overLayService: OverLayHiddenService;
    constructor(
        private el: ElementRef,
        private utilService: UtilService,
        private defaultConfigService: DefaultConfigService,
        private injector: Injector
    ) {
        this.defaultConfig = this.defaultConfigService.getDefaultConfig();
        if (this.injector) {
            this.localeService = this.injector.get(LocaleService);
            this.dtService = this.injector.get(DateTimeHelperService);
            this.notifySer = this.injector.get(NotifyService, null);
            if (this.notifySer) {
                this.notifySer.config.position = 'top-center';
            }
        }
        this.localeConfig = new DatepickerLocaleService();
        this.vcRef = this.injector.get(ViewContainerRef, null);
        this.cfr = this.injector.get(ComponentFactoryResolver, null);
        this.renderer = this.injector.get(Renderer2, null);
        this._applicationRef = this.injector.get(ApplicationRef);
        this.cdr = this.injector.get(ChangeDetectorRef);

        this.overLayService = new OverLayHiddenService();

        this.commonUtils = this.injector.get(CommonUtils, new CommonUtils());
    }

    ngOnInit(): void {

        this._ngControl = this.injector.get(NgControl, null);

        this.initPlaceholder();
        this.mergeDateOptions();
        if (this._beginValue && this._endValue) {
            this.setValue(this._beginValue + this.dateRangeDatesDelimiter + this._endValue);
        }
        this._initFinished = true;
        this.datePicekrService = new DatePickerService(this.dateOpts);
    }

    private initPlaceholder() {
        if (this.localeService) {
            this.locale = this.localeService.getValue('locale');
            this.localDateOpts = this.localeConfig.getLocaleOptions(this.locale);
            this.placeholder = this.placeholder
                ? this.placeholder
                : this.localDateOpts.placeholder
                    ? this.localDateOpts.placeholder
                    : 'è¯·éæ©æ¥æ';
            if (!this.beginPlaceholder) {
                this.beginPlaceholder = this.localDateOpts.range.begin || this.placeholder;
            }

            if (!this.endPlaceholder) {
                this.endPlaceholder = this.localDateOpts.range.end || this.placeholder;
            }
        }
    }

    private mergeDateOptions() {
        this.dateOpts = { ...this.defaultConfig, ...this.buildOptions() };

        if (this.dateOpts.dateFormat) {
            if (!this._dateFormat) {
                this.dateFormat = this.dateOpts.dateFormat;
                this.dateOpts.dateFormat = this.dateFormat;
            }
        }

        if (this.showTime && !this._timeFormat) {
            this._timeFormat = 'HH:mm:ss';
            this.dateOpts.timeFormat = this._timeFormat;
        }

        if (this.dateOpts.returnFormat) {
            if (!this.returnFormat) {
                this.returnFormat = this.dateOpts.returnFormat;
            }
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.locale && changes.locale.isFirstChange()) {
            this.localDateOpts = this.localeConfig.getLocaleOptions(this.locale);
        }
        if (changes) {
            let flag = false;

            const inputs = ['showTime', 'showType', 'dateRange', 'maxDate', 'minDate', 'monthRangeValue', 'maxSelected', 'separator', 'selectedOrderBy'];


            Object.keys(changes).forEach(e => {
                if (!changes[e].isFirstChange() && (this.dateOpts[e] || inputs.includes(e))) {
                    flag = true;
                }
            });
            if (flag) {
                this.dateOpts = { ...(this.dateOpts ||this.defaultConfig), ...this.buildOptions() };
            }
        }
        if (
            changes.readonly &&
            !changes.readonly.currentValue &&
            !changes.readonly.firstChange &&
            !this.value &&
            this.useDefault
        ) {
            this.setDefaultValue();
        }
    }

    ngAfterViewInit() {
        if (this._ngControl && this._ngControl.control) {
            this._updateOn = this._ngControl.control.updateOn;
        }

        this._timer = setTimeout(() => {
            this.setDefaultValue();
        });
    }

    ngOnDestroy(): void {
        clearTimeout(this._timer);
        this.closeSelector();

        this.overLayService.destory(this.el.nativeElement);
        this.overLayService = null;
    }

    @HostListener('mouseenter', ['$event']) onMouseEnter(event) {
        if (this.value && !this.readonly && !this.disabled) {
            if (this.value && this.clearIcon) {
                this.clearIcon.nativeElement.style.visibility = '';
            }
            if (this.dateOpts.dateRange) {
                if (this.dateOpts.showTime) {
                    this.isActiveTip = this.el.nativeElement.getBoundingClientRect().width < 300;
                } else {
                    this.isActiveTip = this.el.nativeElement.getBoundingClientRect().width < 190;
                }
            } else {
                if (this.dateOpts.showTime) {
                    this.isActiveTip = this.el.nativeElement.getBoundingClientRect().width < 170;
                } else {
                    this.isActiveTip = this.el.nativeElement.getBoundingClientRect().width < 120;
                }
            }
        }
    }

    @HostListener('mouseleave', ['$event']) onMouseLeave(event) {
        if (!this.readonly && !this.disabled && this.clearIcon) {
            this.clearIcon.nativeElement.style.visibility = 'hidden';
        }
    }

    onBlur(e) {
        this.totalFocus = false;

        let _runblur = true;
        if (this.value) {
            try {
                this.value = this.transform(this.value);
                const valid = this._isValid(this.value);
                if (!valid) {
                    this.clearDate();
                    _runblur = false;
                }
            } catch (e) {
                this.clearDate();
                _runblur = false;
            }
        }

        const updateModel = () => {
            if (!this._valueChangeEmitted) {
                const realDate = this.dateFrom(this.transform(this.value, this.returnFormat));
                this.onNgModelChange(this.value, realDate, true);
                this.onModelTouched();
            }
        };

        if (this.editable && _runblur) {
            if (this['inDatagrid']) {
                updateModel();
            } else {
                setTimeout(updateModel, 250);
            }
        }
        this._valueChangeEmitted = false;
        if (this._mousedownEvent) {
            this._mousedownEvent();
            this._mousedownEvent = null;
        }
        this.blur.emit();
    }

    onFocus(e) {
        this.totalFocus = true;
        this.registerMouseDownHandle();
        this.focus.emit();
    }

    onInputClick(event) {
        event.stopPropagation();
        if (!this.readonly && !this.disabled) {
            this.registerMouseDownHandle();
            this.toggleCalendar(false);
        }
    }

    private registerMouseDownHandle() {
        if (!this._mousedownEvent) {
            this._mousedownEvent = this.renderer.listen(document, 'mousedown', (e: any) => {
                if (e.target.className.toString().indexOf('SVGAnimatedString') > -1) {
                    return;
                }

                if (e.target.closest('.dynamic-view-item')) {
                    return;
                }

                if (e.target.closest('.f-cmp-datepicker') ||
                    e.target.closest('.f-datepicker-container') || e.target.className.indexOf('f-icon-date') > -1) {
                    if (this.dateInput) {
                        this.renderer.setStyle(this.dateInput.nativeElement, 'unselectable', 'on');
                    }
                    e.preventDefault();
                }
            });
        }
    }

    setDefaultValue() {
        if (!this.readonly && !this.value && this.useDefault) {
            const now = new Date();
            let nowValue = '';
            if (!this.dateOpts.dateRange) {
                nowValue = this.dateTo(now);

            } else {
                nowValue =
                    this.dateTo(now) +
                    this.dateRangeDatesDelimiter +
                    this.dateTo(new Date(now.setMonth(now.getMonth() + 1)));

            }
            if (this.datePicekrService.validate(nowValue)) {
                this.value = nowValue;
                this.onNgModelChange(this.value);
                this.onModelTouched();
            }
        }
    }

    clearDynamicDate($event = null) {
        if ($event) {
            $event.stopPropagation();
        }

        this.dateOpts.dynamicValueChanged(null);
    }

    clearDate($event: MouseEvent = null) {
        if ($event) {
            $event.stopPropagation();
        }

        this._SELECT_DATE_ = null;

        if (!this.disabled) {
            this._realRangeValue = null;
            this._realValue = null;
            this.selectedWeek = null;
            this.onDateChanged({
                isRange: this.dateOpts.dateRange,
                singleDate: {
                    date: this.utilService.resetDate(),
                    jsDate: null,
                    formatted: EMPTY_STR,
                    epoc: 0
                },
                dateRange: {
                    beginDate: this.utilService.resetDate(),
                    beginJsDate: null,
                    beginEpoc: 0,
                    endDate: this.utilService.resetDate(),
                    endJsDate: null,
                    endEpoc: 0,
                    formatted: EMPTY_STR
                }
            });
            this.closeSelector(CalToggle.CloseByCalBtn);
            this.onModelChange(null);
            this.clear.emit();
            if (this.clearIcon) {
                this.clearIcon.nativeElement.style.visibility = 'hidden';
            }
        }
    }

    onSingleInputNgModelChange($event) {
        this.value = $event || '';
        this._realValue = this.value ? this.dateFrom($event) : '';
        this.closeSelector();
    }


    onNgModelChange(value: any, realdate = null, emitValueChange = false) {
        // this.value = value;
        if (this.dateRange || this.showType == ShowType.selectWeek) {

            const tmpArr = value ? value.split(this.dateRangeDatesDelimiter) : ['', ''];
            const _beginValue = this.transform(tmpArr[0], this.returnFormat);
            const _endValue = this.transform(tmpArr[1], this.returnFormat);

            this._beginValue = this.transform(tmpArr[0]);
            this._endValue = this.transform(tmpArr[1]);


            value = _beginValue && _endValue ? _beginValue + this.dateRangeDatesDelimiter + _endValue : '';
            this._realRangeValue = value;
            this.onModelChange(value);
            this.cdr.detectChanges();
            this.beginValueChange.emit(this._beginValue);
            this.endValueChange.emit(this._endValue);

            const p = {
                date: null,
                formatted: this.value,
                returnFormatted: this._realRangeValue,
                cmpRef: this
            };

            this.valueChange.emit(p);
        } else {

            if (value === '') {
                this.value = '';
                this._onModelChange(null, emitValueChange);
                return;
            }

            if (realdate) {
                this._realValue = this.getRealReturnFormatted(realdate);
                this._onModelChange(this._realValue, emitValueChange);

                if (this.dateInput && this.dateInput.nativeElement.value !== this.value) {
                    this.renderer.setProperty(this.dateInput.nativeElement, 'value', this.value);
                }
            } else {
                if (this._isValid(value)) {
                    this._realValue = this.getRealReturnFormatted(realdate);
                    if (this.dateInput) {
                        this.renderer.setProperty(this.dateInput.nativeElement, 'value', this.value);
                    }
                    this._onModelChange(this._realValue, emitValueChange);
                }
            }

        }
    }

    private _onModelChange(realValue, emit) {
        this._realValue = realValue;
        this.onModelChange(realValue);
        if (emit) {
            const p = {
                date: this.utilService.isDateValid(this.value, this.dateOpts, true),
                formatted: this.value,
                returnFormatted: realValue,
                cmpRef: this
            };

            if (this.valueChange.observers.length) {
                if (this.whenValueChangedThenCloseSelectorPanel) {
                    this.closeSelector();
                }

                this.valueChange.emit(p);
            }
        }
    }


    private getRealReturnFormatted(realdate: any) {

        if (realdate) {
            if (this.returnType === 'Date') {
                return realdate;
            } else {
                if (this.returnFormat) {
                    return this.dtService.formatTo(realdate, this.returnFormat);
                }
                return realdate;
            }
        } else {
            return this.dateFrom(this._realValue || this.value) || '';
        }
    }

    onDateRangeInputBlur(event: any) {
        this.setValue(this._beginValue + this.dateRangeDatesDelimiter + this._endValue);
        this.onNgModelChange(this._realRangeValue || this.value);
    }

    openCalendar(): void {
        if (this.disabled) {
            return;
        }

        let val = this._realValue;

        if (!this.multiSelect) {
            if (this.dateRange || this.showType == ShowType.selectWeek) {
                val = this._realRangeValue;
            } else {
                if (this.returnType === 'Date') {
                    val = this.transform(val, this.returnFormat);
                }
            }
        }

        if (this.cRef === null) {
            this.cRef = this.calendarRef.createComponent(
                this.cfr.resolveComponentFactory(CalendarComponent)
            );

            this.datePicekrService.appendSelector(this.cRef.location.nativeElement);

            this.datePicekrService.registerScrollEvent(() => {
                this.closeSelector();
            });

            this.cRef.instance.dateHlp = this.dtService;

            if (this.showType === 4 && this.selectedWeek) {
                this.cRef.instance.selectedWeek = this.selectedWeek;
            }

            if (this.multiSelect) {
                this.cRef.instance.multiDatesChanged = (dates: any[]) => {
                    this.value = dates.map(n => n.value).join(this.separator);
                    this._realValue = dates.map(n => this.dtService.formatTo( `${n.year}-${n.month}-${n.day}` , this.returnFormat)).join(this.separator);
                    this.multiSelectedChanged();
                }

                this.cRef.instance.showNotify = () => {
                    const msg =  this.localDateOpts.message['102'].replace('${0}', this.maxSelected);
                    if (this.notifySer) {
                        this.notifySer.warning(msg);
                    } else {
                        alert(msg);
                    }
                };
            }

            this.cRef.instance.initialize(
                this.dateOpts,
                '',
                this.datePicekrService.getSelectorPosition(this.el.nativeElement, this.cRef),
                val,
                (dm: IMyDateModel, close: boolean) => {

                    if (this.dateOpts.dateRange && this.showTime && dm.dateRange.endJsDate < dm.dateRange.beginJsDate) {
                        // const { year: beginYear, month: beginMonth,  day: beginDay  } = {...dm.dateRange.beginDate};
                        // const { year: endYear, month: endMonth,  day: endDay  } = {...dm.dateRange.endDate};
                        // error message:  The end time must not be earlier than the start time
                        // error message:  çµææéä¸å¾æ©äºéå§æé
                        const msg = this.localDateOpts.message['101'];
                        if (this.notifySer) {
                            this.notifySer.warning(msg);
                        } else {
                            alert(msg);
                        }
                        return;
                    }
                    this.selectedWeek = this.cRef.instance.selectedWeek;
                    this.onDateChanged(dm);
                    if (close) {
                        this.closeSelector(CalToggle.CloseByDateSel);
                    }
                },
                (cvc: IMyCalendarViewChanged) => {
                    // this.emitCalendarChanged(cvc);
                },
                (rds: IMyRangeDateSelection) => {
                    // this.emitRangeDateSelection(rds);
                },
                () => {
                    this.closeSelector(CalToggle.CloseByEsc);
                }
            );

            this.cRef.instance.dynamicViewShow.subscribe((e: {showDynamicView: boolean}) => {
                const t = Object.assign(e, {dynamicValue: this.dynamicValue, singleValue: this._realValue, instance: this})
                this.dynamicViewChanged.emit(t);
            })

            // this.cdr.detectChanges();
        } else {
            this.datePicekrService.appendSelector(this.cRef.location.nativeElement);
        }

        this.overLayService.registerMouseEvent(this.el.nativeElement, (e: MouseEvent) => {
            const t: any = e.target;
            const notClose = (this.cRef && this.cRef.location.nativeElement.contains(t)) || 
            t.closest('.multi-date-select') || (t.className && t.className.indexOf('multi-date-select') > -1);
            if (notClose) {
                return false;
            }
            this.closeSelector();
        }, { onlyTopWindow: true});

        this.cRef.changeDetectorRef.detectChanges();
        // this.preventClose = false;
    }
    closeSelector(reason?: number): void {
        if (this.cRef !== null) {
            this.calendarRef.remove(this.calendarRef.indexOf(this.cRef.hostView));
            this.cRef = null;
            // this.cdr.detectChanges();
            const container = document.querySelector('.date-overlay-container');
            if (container.childElementCount) {
                container.remove();
            }
            this.renderer.setStyle(container, 'pointer-events', '');
        }
        this.totalFocus = false;
        if (this.dateOpts.dateRange) {
            this.beginFocus = false;
            this.endFocus = false;
        }

        if (this.closeCalendarHandler) {
            this.closeCalendarHandler();
            this.closeCalendarHandler = null;
        }

        if (this.datePicekrService) {
            this.datePicekrService.removeMouseEvent();
        }

        this.overLayService.destory(this.el.nativeElement);
    }
    toggleCalendar(close: boolean, emit = true) {
        if (this.disabled) {
            this.totalFocus = false;
            if (this.dateOpts.dateRange) {
                this.beginFocus = false;
                this.endFocus = false;
            }
            return;
        }
        if (this.cRef === null) {
            if (!this.closeCalendarHandler) {
                this.closeCalendarHandler = this.renderer.listen(document, CLICK, () => this.closeSelector(CalToggle.CloseByOutClick));
            }
            this.totalFocus = true;
            this.openCalendar();
            const container = document.querySelector('.date-overlay-container');
            this.renderer.setStyle(container, 'pointer-events', 'auto');

            const zindex = this.commonUtils.getFloatingLayerIndex();
            this.renderer.setStyle(container, 'zIndex', zindex);
        } else {
            let flag = true;
            const container = document.querySelector('.date-overlay-container');
            if (container && this.cRef.location) {
                if (container.hasChildNodes()) {
                    container.childNodes.forEach(el => {
                        if (el === this.cRef.location.nativeElement) {
                            flag = false;
                        }
                    });
                }
            }
            if (flag) {
                this.renderer.setStyle(container, 'pointer-events', 'auto');
                this.totalFocus = true;
                this.openCalendar();
            } else {
                this.totalFocus = false;

                if (this.dateOpts.dateRange) {
                    this.beginFocus = false;
                    this.endFocus = false;
                }
                // document.removeEventListener(CLICK, this.onClickHidden);
                close && this.closeSelector(CalToggle.CloseByCalBtn);
                // this.renderer.setStyle(container, 'pointer-events', '')
                if (emit) {
                    this.close.emit();
                }
            }
        }
    }

    onDateChanged(event: IMyDateModel) {
        this._SELECT_DATE_ = event;
        let valChangeParams: any = '';
        if (event.singleDate) {
            this.value = event.singleDate.formatted;
            this.formatedValue = event.singleDate.formatted;
            const returnFormatted = this.getRealReturnFormatted(event.singleDate.jsDate);
            valChangeParams = { ...event.singleDate, formatted: event.singleDate.formatted, returnFormatted };

            const { year, month, day, hour, minute, second } = event.singleDate.date;

            if (month && (this.dateFormat.indexOf('yyyy') === -1 || this.dateFormat.indexOf('dd') === -1)) {
                const nd = new Date(
                    year || new Date().getFullYear(),
                    month - 1,
                    day || 1,
                    hour || 0,
                    minute || 0,
                    second || 0
                );

                event.singleDate.jsDate = nd;
            }

            let { year: minYear, month: minMonth, day: minDay, hour: minHour, minute: minMinute, second: minSecond } = this.minDate;
            minMonth = this.utilService.padStartZero(minMonth);
            minDay = this.utilService.padStartZero(minDay);
            minHour = this.utilService.padStartZero(minHour);
            minMinute = this.utilService.padStartZero(minMinute);
            minSecond = this.utilService.padStartZero(minSecond);

            const MIN_DATE = new Date(`${minYear}-${minMonth}-${minDay} ${minHour}:${minMinute}:${minSecond}`);
            if (this.minDate.year !== 1840) {
                if (differenceInSeconds(MIN_DATE, event.singleDate.jsDate) > 0) {
                    event.singleDate.jsDate = MIN_DATE;
                    this.value = this.transform(MIN_DATE);
                }
            } else if (this.maxDate.year !== 10000) {
                let { year: maxYear, month: maxMonth, day: maxDay, hour: maxHour, maxute: maxMinute, second: maxSecond } = this.maxDate;
                maxMonth = this.utilService.padStartZero(maxMonth);
                maxDay = this.utilService.padStartZero(maxDay);
                maxHour = this.utilService.padStartZero(maxHour);
                maxMinute = this.utilService.padStartZero(maxMinute);
                maxSecond = this.utilService.padStartZero(maxSecond);

                const MAX_DATE = new Date(`${maxYear}-${maxMonth}-${maxDay} ${maxHour}:${maxMinute}:${maxSecond}`);
                
                if (event.singleDate.date.year === 1840 || differenceInSeconds(MIN_DATE, event.singleDate.jsDate) === 0 || differenceInSeconds(MAX_DATE, event.singleDate.jsDate) < 0) {
                    event.singleDate.jsDate = MAX_DATE;
                    this.value = this.transform(MAX_DATE);
                }
            }

            this.onNgModelChange(returnFormatted, event.singleDate.jsDate);
        } else if (event.dateRange) {
            this.value = event.dateRange.formatted;
            this.formatedValue = event.dateRange.formatted;
            const returnFormatted = event.dateRange.returnFormatted;
            // let returnFormatted = this.dateFrom(event.dateRange.returnFormatted);
            valChangeParams = { ...event.dateRange, formatted: event.dateRange.formatted, returnFormatted };
            this.onNgModelChange(returnFormatted, event.dateRange);
        }
        this.onModelTouched();
        this._valueChangeEmitted = true;
        this.valueChange.emit(valChangeParams);
    }

    private checkMultiSelectedOption() {

        if (this.multiSelect) {

            this.showTime = false;
            this.showType = ShowType.all;
            this.dateRange = false;
            this.enableDynamic = false;

            // è¿åæ ¼å¼å¿é¡»åæ¬å¹´ææ¥
            const fmtList = ['yyyy-MM-dd', 'yyyy/MM/dd','MM/dd/yyyy','yyyyå¹´MMæddæ¥','yyyyMMdd'];
            if (!fmtList.find(n => n === this.returnFormat)) {
                this.returnFormat = 'yyyy-MM-dd';
            }

            if (!fmtList.find(n => n === this.dateFormat)) {
                this.dateFormat = 'yyyy-MM-dd';
            }
        }
    }

    buildOptions() {
        let dateOpts: any;
        if (!this.localDateOpts) {
            this.localDateOpts = this.localeConfig.getLocaleOptions(this.locale);
        }

        if (this.showType === ShowType.noDateAndMonth) {
            this.localDateOpts.dateFormat = 'yyyy';
            this.localDateOpts.returnFormat = 'yyyy';
        }
        // æ£æ¥æ¯å¦å·å¤å¯ç¨æ¥æå¤éçæ¡ä»¶
        this.checkMultiSelectedOption();

        const _showTime = (Number(this.showType) === ShowType.all) ? this.showTime : false;

        dateOpts = {
            localeId: this.locale,
            dateRange: this.dateRange,
            showTime: _showTime,
            showType: Number(this.showType),
            dateFormat: this.dateFormat ? this.dateFormat : this.localDateOpts.dateFormat,
            returnFormat: this.returnFormat ? this.returnFormat : this.localDateOpts.returnFormat,
            minYear: this._minDate.year,
            maxYear: this._maxDate.year,
            highlightDates: this.highlightDates,
            disableDates: this.disableDates,
            showWeekNumbers: this.showWeekNumbers,
            disableDateRanges: [
                {
                    begin: this.disableDateRangesBegin,
                    end: this.disableDateRangesEnd
                }
            ],
            disableUntil: this._minDate,
            disableSince: this._maxDate,
            disableWeekdays: this.disableWeekdays,
            markDates: [
                {
                    dates: this.markDates,
                    color: this.markDatesColor
                }
            ],
            markWeekends: {
                marked: this.isMarkWeekends,
                color: this.markWeekendsColor
            },
            dateRangeDatesDelimiter: this.dateRangeDatesDelimiter,
            shortcuts: this.shortcuts,
            timeFormat: this._timeFormat,
            monthRangeValue: this.monthRangeValue,
            viewType: this.viewType,
            enableDynamic: this.enableDynamic,
            dynamicValue: this.dynamicValue,
            dynamicValueChanged: (e: DynamicData) => {
                this.dynamicValue = e;
                this.dynamicText = e ? e.text : '';
                this.dateOpts.dynamicValue = e;
                this.dynamicValueChange.emit(e);
                this.closeSelector();
            },
            previousMaxDays: this.previousMaxDays,
            futureMaxDays: this.futureMaxDays,
            dynamicLocale: this.localDateOpts.dynamicLocale,
            multiDatesLocale: this.localDateOpts.multiDatesLocale,
            showPresent: this.showPresent,
            hourStep: this.hourStep,
            minuteStep: this.minuteStep,
            secondStep: this.secondStep,
            closeSelectorOnDateSelect: !this.multiSelect,
            multiSelect: this.multiSelect,
            separator: this.separator,
            maxSelected: this.maxSelected,
            selectedOrderBy: this.selectedOrderBy,
            defaultView: DefaultView.Date
        };
        dateOpts.firstDayOfWeek = this.firstDayOfWeek;
        switch (Number(this.showType)) {
            case ShowType.noDate:
                dateOpts.defaultView = DefaultView.Month;
                break;
            case ShowType.noDateAndMonth:
                dateOpts.defaultView = DefaultView.Year;
                // dateOpts.dateFormat = 'yyyy';
                // dateOpts.returnFormat = 'yyyy';
                // this.dateFormat = 'yyyy';
                break;
            case ShowType.selectWeek:
                dateOpts.showWeekNumbers = true;
                dateOpts.dateRange = true;
                // dateOpts.firstDayOfWeek = 'mo';
                break;
            // default:
            // this.returnType = 'String';

        }
        return { ...this.localDateOpts, ...dateOpts };
    }

    dateTo(d: any) {
        const dateFormat = this.dateOpts.dateFormat ? this.dateOpts.dateFormat : this.defaultConfig.dateFormat;
        const monthLabels = this.dateOpts.monthLabels ? this.dateOpts.monthLabels : this.defaultConfig.monthLabels;
        const showTime = this.dateOpts.showTime ? this.dateOpts.showTime : this.defaultConfig.showTime;
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        const day = d.getDate();
        const hour = d.getHours();
        const minute = d.getMinutes();
        const second = d.getSeconds();
        let date: IMyDate;
        if (!showTime) {
            date = { year, month, day };
            this.originTime = { hour, minute, second };
        } else {
            date = { year, month, day, hour, minute, second };
        }
        return this.utilService.formatDate(date, dateFormat, monthLabels);
    }
    // è¿åçå®æ¥æ Date ç±»å
    dateFrom(str: any, ignorRange = false) {
        if (!str) {
            return '';
        }

        const _this = this;

        const dateRange = this.dateOpts.dateRange ? this.dateOpts.dateRange : this.defaultConfig.dateRange;
        const dateFormat = this.dateOpts.dateFormat ? this.dateOpts.dateFormat : this.defaultConfig.dateFormat;
        const returnFormat = this.dateOpts.returnFormat ? this.dateOpts.returnFormat : this.defaultConfig.returnFormat;
        const showTime = this.dateOpts.showTime ? this.dateOpts.showTime : this.defaultConfig.showTime;
        const delimeters: Array<string> = returnFormat.match(/[^(DdMmYy)]{1,}/g);
        let dateValue: Array<IMyDateFormat>;
        const getValue = this.utilService.getDateValue;
        if ((dateRange || this.dateOpts.showType === ShowType.selectWeek) && !ignorRange) {
            const tmpBegin = str.split(this.dateRangeDatesDelimiter)[0];
            const tmpEnd = str.split(this.dateRangeDatesDelimiter)[1];
            let tmpBeginDate = this.utilService.isDateValid(tmpBegin, this.dateOpts, true);
            let tmpEndDate = this.utilService.isDateValid(tmpEnd, this.dateOpts, true);
            tmpBeginDate = this.utilService.isInitializedDate(tmpBeginDate) ? tmpBeginDate : this.dateOpts.disableUntil;
            tmpEndDate = this.utilService.isInitializedDate(tmpEndDate) ? tmpEndDate : this.dateOpts.disableSince;
            return (
                this.utilService.formatDate(tmpBeginDate, returnFormat, this.defaultConfig.monthLabels) +
                this.dateRangeDatesDelimiter +
                this.utilService.formatDate(tmpEndDate, returnFormat, this.defaultConfig.monthLabels)
            );
        } else {
            if (this.returnType === 'Date') {
                if (str && str instanceof Date) {
                    return str;
                }
                return convert(str, getValue, this.originTime);
            } else {
                const tmpDate = this.utilService.isDateValid(str, this.dateOpts, true);
                return this.utilService.formatDate(tmpDate, returnFormat, this.defaultConfig.monthLabels);
            }
        }

        function convert(v, _getValue: any, originTime = { hour: 0, minute: 0, second: 0 }) {
            let fmt = returnFormat;
            if (_this.returnType === 'Date') {
                fmt = 'yyyy-MM-dd' + (showTime ? ' HH:mm:ss' : '');
            }
            if (showTime) {
                const date = v.split(' ')[0];
                let time = v.split(' ')[1];

                dateValue = _getValue(date, fmt, delimeters);
                if (time) {
                    time = time.replace(/[æ¶,å]/g, ':').replace(/[ç§]/, '');
                    const [h, m, s] = time.split(':');
                    const hour = h;
                    const minute = m;
                    const second = s ? s : '';

                    dateValue[3] = { value: hour, format: 'hh' };
                    dateValue[4] = { value: minute, format: 'mm' };
                    if (second) {
                        dateValue[5] = { value: second, format: 'ss' };
                    }
                }
            } else {
                const date = v.split(' ')[0];
                dateValue = _getValue(date, fmt, delimeters);
            }


            let year = Number(dateValue[0] ? dateValue[0].value : 1970);
            const yearValue = dateValue[0];
            if (yearValue.format) {
                if (!yearValue.value || yearValue.value.length !== yearValue.format.length) {
                    year = null;
                }
            }

            const month = Number(dateValue[1] ? dateValue[1].value : 1) - 1;
            const day = Number(dateValue[2] ? dateValue[2].value : 1);
            const _hour = dateValue[3] ? Number(dateValue[3].value) : originTime.hour;
            const _minute = dateValue[4] ? Number(dateValue[4].value) : originTime.minute;
            const _second = dateValue[5] ? Number(dateValue[5].value) : originTime.second;

            if (!year) {
                return null;
            }
            return new Date(year, month, day, _hour, _minute, _second);
        }
    }

    transform(value: any, _fmt = this.dateOpts.dateFormat) {
        value = value ? value : '';
        const { returnFormat, dateFormat, showTime } = this.dateOpts;
        let _tmpDate = null;
        if (typeof value === 'string') {
            _tmpDate = parse(value, returnFormat, new Date());

            if (!isValid(_tmpDate)) {
                if (this._SELECT_DATE_ && this._SELECT_DATE_.singleDate) {
                    _tmpDate = this._SELECT_DATE_.singleDate.jsDate;
                } else {
                    if (this._realValue) {
                        _tmpDate =  parse(this._realValue, returnFormat, new Date());
                    }
                }
            }
        } else {
            if (value instanceof Date) {
                _tmpDate = value;
            }
        }
        let formattedVal = value;
        if (isValid(_tmpDate)) {
            formattedVal = this.dtService.formatTo(_tmpDate, _fmt);
            return formattedVal;
        } else {
            // å¼å®¹å¹´ææ¥,å¹´æ,å¹´æ ¼å¼
            value = value.replace(/[å¹´,æ]/g, '-').replace(/[æ¥]/, '');
            if (value[value.length - 1] === '-') {
                value = value.substr(0, value.length - 1);
            }

            if (isValid(new Date(value))) {
                formattedVal = this.dtService.formatTo(value, _fmt);
            } else {
                value = '';
            }
        }
        if (value) {
            if (this.dateFrom(value, true) === '') {
                const tmpDate = this.utilService.isDateValid(
                    value,
                    Object.assign({}, this.dateOpts, {
                        dateFormat: returnFormat
                    })
                );
                formattedVal = this.utilService.formatDate(tmpDate, _fmt, this.defaultConfig.monthLabels);
            }
        }
        return formattedVal;
    }

    setValue(value: string) {
        if (this.value !== value) {
            if (this.dateOpts.dateRange) {
                const _tmpDateArr = value.split(this.dateRangeDatesDelimiter);
                const beginStr = _tmpDateArr[0];
                const endStr = _tmpDateArr[1];
                this._beginValue = this.transform(beginStr);
                this._endValue = this.transform(endStr);
                this.value = this._beginValue && this._endValue ? this._beginValue + this.dateRangeDatesDelimiter + this._endValue : '';
            } else {
                if (value) {
                    this.value = this.transform(value);
                } else {
                    this.value = '';
                }
            }

            this.cdr.markForCheck();
        }
    }

    updateValue(value: string) {
        if (this.dateOpts.dateRange) {
            const _tmpDateArr = value.split(this.dateRangeDatesDelimiter);
            const beginStr = _tmpDateArr[0];
            const endStr = _tmpDateArr[1];
            this._beginValue = this.transform(beginStr);
            this._endValue = this.transform(endStr);
            this.value = this._beginValue && this._endValue ? this._beginValue + this.dateRangeDatesDelimiter + this._endValue : '';
        } else {
            this.value = this.transform(value);
        }
    }

    getValueByType(val) {
        if (val instanceof Date) {
            this.returnType = 'Date';
            // return this.dateTo(val);
            return val;
        } else if (val && val instanceof Object) {
            const { begin, end } = val;
            const beginStr = begin instanceof Date ? this.dateTo(begin) : '';
            const endStr = begin instanceof Date ? this.dateTo(end) : '';

            this.returnType = 'Object';
            return beginStr && endStr ? beginStr + this.dateRangeDatesDelimiter + endStr : '';
        } else if (val && typeof val === 'string') {
            if (val.indexOf('T') > -1) {
                val = val.replace('T', ' ');
            }
            this.returnType = 'String';
            return val;
        } else {
            return '';
        }
    }
    
    writeValue(val: any): void {
        this._SELECT_DATE_ = null;
        if (!this.multiSelect) {
            if (typeof val === 'object' && val && !isDate(val)) {
                this.dynamicValue = val;
                this.dynamicText = this.utilService.formatDynamicValue(val, this.dateOpts.dynamicLocale, this.locale === 'EN_US');
                this.dateOpts.showDynamicView = true;
                this.dateOpts.dynamicValue = this.dynamicValue;
            } else {
                // this.dateOpts.showDynamicView = false;
                this._realValue = val;
                if (this.dateRange) {
                    this._realRangeValue = val;
                }

                this.setValue(this.getValueByType(val));
            }
        } else {
            // tfs  638823
            if (!val) {
                val = '';
                this.value = '';
            }

            if (val) {
                this.value = val.split(this.separator).map(n => this.transform(n)).join(this.separator);
            }
            this._realValue = val;
        }
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
    onPrevFocus(value: boolean): void {
        this.beginFocus = true;
        if (this.endFocus == true) {
            this.endFocus = !this.endFocus;
        }
        this.PrevFocus.emit();
    }
    onNextFocus(value: boolean): void {
        this.endFocus = true;
        if (this.beginFocus == true) {
            this.beginFocus = !this.beginFocus;
        }
        this.NextFocus.emit();
    }

    private _convert2dateString(val: string, realValue = false) {
        if (val) {
            let t = val.replace(/[å¹´,æ]/g, '-').replace(/[æ¥,å·]/g, ' ').replace(/[æ¶,ç¹,å,åé]/g, ':').replace('ç§', '');

            if (this.showType === ShowType.noDateAndMonth && t.indexOf('-') === -1) {
                t += '-';
            }

            // æ¿æ¢è¿ç»­çç©ºæ ¼å­ç¬¦ä¸ºåä¸ªç©ºæ ¼
            var checkSpaceReg = /(\s)\1{1,}/g;
            if (t.match(checkSpaceReg)) {
                t.match(checkSpaceReg).forEach(n => {
                    if (n[0] === ' ') {
                        t = t.replace(n,  ' ');
                    }
                });
            }

            if (realValue) {
                const objDate = this.utilService.isDateValid(val, this.dateOpts, true);
                if (objDate) {
                    let { year, month, day, hour, minute, second} = objDate;
                    if (!year) {
                        year = new Date().getFullYear();
                    }
                    if (!month) {
                        month = new Date().getMonth();
                    }

                    if (!day) {
                        day = 1;
                    }

                    if (!hour) {
                        hour = 0;
                    }

                    if (!minute) {
                        minute = 0;
                    }

                    if (!second) {
                        second = 0;
                    }

                    const _datePart = `${year}-${this.utilService.padStartZero(month)}-${this.utilService.padStartZero(day)}`;
                    const _timePart = `${this.utilService.padStartZero(hour)}:${this.utilService.padStartZero(minute)}:${this.utilService.padStartZero(second)}`;

                    return `${_datePart} ${_timePart}`;
                }
            }

            if (t[t.length - 1] === '-') {
                // t = t.substr(0, t.length - 1);
                t += '01';
            }

            if (t[t.length - 1] === ':') {
                t = t.substr(0, t.length - 1);
            }

            return t.replace(/^\s+|\s+$/g, '');
        }

        return val;
    }


    private _isValid(value: any) {
        value = this._convert2dateString(value);
        if (value) {
            if (this.dateFormat.indexOf('yyyy') === -1 || this.dateFormat.indexOf('dd') === -1) {
                const _tmpDate = parse(this.value, this.dateFormat, new Date());
                if (this._realValue) {
                    if (this.returnType === 'Date') {
                        return isValid(this._realValue);
                    } else {
                        return isValid(new Date(this._convert2dateString(this._realValue, true)));
                        // return isValid(parse(this._realValue, this.returnFormat, new Date()));
                    }
                }

                const d = this.utilService.isDateValid(value, this.dateOpts);
                if (d) {
                    if (d.year || d.month) {
                        const cdate = new Date();
                        const year = cdate.getFullYear();
                        const str = (this.dateOpts.returnFormat || 'yyyy-MM-dd')
                            .replace('yyyy', '' + (d.year || year)).replace('MM', '' + d.month).replace('dd', '1');
                        return isValid(new Date(str));
                    }
                    return false;
                }
                return isValid(value);
            } else {
                const reg = /^\d{1,}$/;
                if (reg.test(value) && this.dateFormat.indexOf('yyyyMMdd') > -1) { // éªè¯ä¼ å¥çæ ¼å¼ä¸º yyyyMMddHHmmss
                    const _r =  this._isValid2(value);
                    if (_r.isValided) {
                        this._realValue = this.getRealReturnFormatted(_r.date);
                        this.value = this.transform(_r.date);
                    }
                    return _r.isValided;
                } else {
                    const _tmpDate = parse(value, this.dateFormat, new Date());
                    const d = this.utilService.isDateValid(this.value, this.dateOpts);
                    return isValid(_tmpDate) || this.utilService.isInitializedDate(d);
                }
            }
        }
        return false;
    }

    private _isValid2(value: string): any {
        let year = 0;
        let month = 0;
        let day = 0;
        let hour = 0;
        let minute = 0;
        let seconds = 0;

        const df = this.dateFormat;

        if (df.includes('yyyy')) {
            if (value) {
                year = +value.slice(0, 4);
                value = value.slice(4);
            } else {
                return false;
            }
        }
        if (df.includes('MM')) {
            if (value) {
                month = +value.slice(0, 2) - 1;
                value = value.slice(2);

                if (month < 0) {
                    month = 0;
                }
            } else {
                return false;
            }
        }
        if (df.includes('dd')) {
            if (value) {
                day = +value.slice(0, 2);
                value = value.slice(2);
            } else {
                return false;
            }
        }
        if (df.includes('HH')) {
            if (value) {
                hour = +value.slice(0, 2);
                value = value.slice(2);
            }
        }
        if (df.includes('mm')) {
            if (value) {
                minute = +value.slice(0, 2);
                value = value.slice(2);
            }
        }
        if (df.includes('ss')) {
            if (value) {
                seconds = +value.slice(0, 2);
            }
        }

        const d = new Date(year, month, day, hour, minute, seconds);
        return {
            isValided: isValid(d),
            date: d
        };
    }

    private multiSelectedChanged() {
        this.onModelChange(this._realValue);
        const p = {
            formatted: this.value,
            returnFormatted: this._realValue,
            cmpRef: this
        };
        this.onModelTouched();
        this.closeSelector(CalToggle.CloseByDateSel);
        this.valueChange.emit(p);

        if (!this.value) {
            this.clear.emit();
        }
    }

    onRemoveDate(d: {value: string, index: number}) {
        if (!d) {
            return;
        }
        const {value, index} = d;
        this.value = this.value.split(this.separator).filter(n => n!== value).join(this.separator);
        this._realValue = this._realValue.split(this.separator).filter((n, i) => i !== index).join(this.separator);

        this.multiSelectedChanged();
        this.cdr.detectChanges();
    }
}
